// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__8xyIo","errors":"Errors_errors__3XZYa"};